exports = module.exports = require("../../../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._3Yg_ZwdaR6PzHQXIFkYTn0{height:100%;width:100%;overflow:auto}", ""]);
// Exports
exports.locals = {
	"composeFormDroppable": "_3Yg_ZwdaR6PzHQXIFkYTn0"
};